// Community Resources page
import { CommunityResources } from '../components/CommunityResources';

export function CommunityResourcesPage() {
  return (
    <div className="pt-32 pb-20">
      <CommunityResources />
    </div>
  );
}

